export default __webpack_public_path__ + "static/media/245.a2adb37e.png";